import { ComponentProps } from '@stitches/react'
import { Link } from 'components/Link'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { FeedArticle } from 'features/Blog/utils/parseFeed'
import Image from 'next/image'
import { capitalize } from 'utils/capitalize'
import { PostCardContent, PostCardImage, PostCardRoot } from './PostCard.styles'

export const mapVariantsToIndex = ['white', 'neutral', 'secondary-dark', 'secondary-light'] as const

type PostCardOwnProps = ComponentProps<typeof PostCardRoot>

type PostCardProps = PostCardOwnProps & {
  article: FeedArticle
}

export const PostCard = ({ article, ...rest }: PostCardProps) => {
  return (
    <Link href={`/blog/${article.slug}`} passHref>
      <PostCardRoot {...rest}>
        <PostCardImage>
          {article.image && (
            <Image
              src={article.image}
              alt={article.title}
              width="377"
              height="208"
              objectFit="cover"
              objectPosition="top"
            />
          )}
        </PostCardImage>

        <PostCardContent>
          {article.tags.length > 0 && (
            <Text weight="semiBold" color="primary-500">
              {article.tags.map((tag) => capitalize(tag)).join(' ')}
            </Text>
          )}

          <Stack direction="column" className="wrapper">
            <Text
              as="h5"
              size="h5"
              weight="semiBold"
              css={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 2,
                overflow: 'hidden',
              }}
            >
              {article.title}
            </Text>

            <Text
              css={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 6,
                overflow: 'hidden',
              }}
            >
              {article.summary}
            </Text>
          </Stack>
        </PostCardContent>
      </PostCardRoot>
    </Link>
  )
}
